import * as React from "react";
const SwitchOffIcon = () => /* @__PURE__ */ React.createElement("svg", {
  width: 42,
  height: 23,
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "a"
}, /* @__PURE__ */ React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0.5,
  offset: "0%"
}), /* @__PURE__ */ React.createElement("stop", {
  stopColor: "#E4EAF6",
  stopOpacity: 0.5,
  offset: "100%"
}))), /* @__PURE__ */ React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ React.createElement("rect", {
  width: 42,
  height: 23,
  rx: 11.5,
  fill: "#F8F9FC"
}), /* @__PURE__ */ React.createElement("rect", {
  stroke: "#E5E5E5",
  strokeWidth: 1.081,
  x: 0.541,
  y: 0.541,
  width: 40.919,
  height: 21.919,
  rx: 10.959
}), /* @__PURE__ */ React.createElement("circle", {
  cx: 8.5,
  cy: 8.5,
  r: 8.5,
  fill: "#000",
  fillRule: "nonzero",
  transform: "translate(3 3)"
}), /* @__PURE__ */ React.createElement("circle", {
  cx: 8.5,
  cy: 8.5,
  r: 8.5,
  fill: "#FFF",
  transform: "translate(3 3)"
}), /* @__PURE__ */ React.createElement("circle", {
  cx: 8.5,
  cy: 8.5,
  r: 8.5,
  fill: "url(#a)",
  stroke: "#E5E5E5",
  strokeWidth: 1.081,
  transform: "translate(3 3)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "m34.044 13.787-2.2-2.2 2.2-2.2a.443.443 0 0 0 0-.629l-.628-.628a.446.446 0 0 0-.63 0l-2.198 2.2-2.2-2.2a.445.445 0 0 0-.629 0l-.628.628a.443.443 0 0 0 0 .629l2.2 2.2-2.2 2.2a.443.443 0 0 0 0 .628l.628.629a.445.445 0 0 0 .629 0l2.2-2.2 2.199 2.2a.446.446 0 0 0 .629 0l.628-.629a.443.443 0 0 0 0-.628",
  fill: "#E5E5E5",
  fillRule: "nonzero"
})));
export default SwitchOffIcon;
